import { Routes, Route } from "react-router-dom";
import { Suspense } from "react";
import Loader from "components/common/loader";
import Dashboard from "components/features/dashboard/dashboard";
import { ProtectedRoute } from "./protectedRoute";
import Home from "components/features/home/home";
import { useAuth } from "@clerk/clerk-react";
import Sidebar from "components/layout/sidebar/sidebar";

export function AppRouter(): JSX.Element {
  const { isSignedIn } = useAuth();
  return (
    <>
      <div className="flex h-screen relative">
        {isSignedIn && <Sidebar />}

        <Suspense fallback={<Loader />}>
          <div className="p-6 h-full w-full">
            <Routes>
              <Route path="/" element={isSignedIn ? <Dashboard /> : <Home />} />

              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </div>
        </Suspense>
      </div>
    </>
  );
}
